'use strict';

import '../styles/front.scss';
import 'swiper/css/bundle';
import { Donation } from './shortcodes/Donation.js';
import { Form } from './helpers/Form.js';
import CreateACampaignForm from "./components/CreateACampaignForm.js";
// import { SignUpForm } from './components/SignUpForm.js';
import { Checkout } from './components/Checkout.js';
import { Header } from './components/Header.js';
import { Datatables } from "./components/Datatables.js";
import { Helper } from "./helpers/Helper.js";
import { MultiStepForms } from './components/MultiStepForm/MultiStepForms.js';
import { CopyToClipboard } from "./components/CopyToClipboard.js";
import { MyAccount } from "./components/MyAccount.js";
import { Ajax } from "./helpers/Ajax.js";
import Confetti from "./components/Confetti.js";
import { MonthlyGiving } from "./components/MonthlyGiving.js";
import { DonationsForm } from "./components/DonationsForm.js";
import { DonationOrderMetabox } from "./metaboxes/DonationOrderMetabox.js";
import {Tooltip} from "./components/Tooltip.js";
import DatePicker from "./components/DatePicker.js";
import MyAccountEdit from "./components/MyAccountEdit.js";
import { CopyText } from "./components/CopyText.js";
import FilterableCardsList from "./components/FilterableCardsList.js";
import { DonationVariation } from "./components/DonationVariation.js";
import GatewayTabs from "./components/GatewayTabs.js";
import Slider from "./components/Slider.js";
import {ChoiceSelect} from "./components/ChoiceSelect.js";


document.addEventListener( 'DOMContentLoaded', () => {
	const helper = new Helper();
	helper.disableNumberInputScroll();
	helper.setTimezoneOffset();
	helper.setUserCountryCode();

	new Ajax().handlers();

	new Datatables();
	new Donation();
	new Checkout();
	new Header();
	new MyAccount();
	new MonthlyGiving();
	new DonationOrderMetabox();
	new CopyText();
	new DonationVariation();

	// new SignUpForm();

	const donationsForm = new DonationsForm();
	donationsForm.watchOtherAmountToggle();
	donationsForm.watchVariationsChange();

	new MultiStepForms();

	const form = new Form();
	form.watchCheckboxes();
	form.addCampaignToCart();

	const createCampaignForm = new CreateACampaignForm();
    createCampaignForm.init();

	const copyToClipboard = new CopyToClipboard();
	copyToClipboard.init('.copy_to_clipboard_button');


	if (document.body.classList.contains('levcharity-confetti')) {
		const confetti = new Confetti(300);
		confetti.initialize();
	}

	new Tooltip();
	new DatePicker();

	new MyAccountEdit();

	GatewayTabs();

	const choiceSelect = new ChoiceSelect();
	choiceSelect.singleSelect();
	choiceSelect.singleInput();
	choiceSelect.multiSelect( '.multi_choices_select select');

	new Slider();
} );
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-custom-products-archive-list-levit-block .products_archive_wrapper')?.forEach(wrapper => {
		const campaignsList = new FilterableCardsList(wrapper);

		campaignsList.generateCampaignsArray();
		campaignsList.initialize();
	})
});
